<template>
  <div>
    <el-form ref="form" :rules="rules" :model="dataForm" label-position="top" style="text-align:left">
      <div ref="name"></div>
      <!-- TITUL - MENO - PRIEZVISKO - TITUL ZA MENOM -->
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4">
          <el-form-item>
            <span slot="label" class="hm-cell">{{$t('employee.lbl.title')}}</span>
            <el-select v-model="dataForm.title" clearable multiple :placeholder="$t('employee.lbl.title')" style="width:100%" >
              <el-option v-for="item in optTitle"
                :key="item._id" :label="item.name" :value="item._id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
          <el-form-item prop="firstname" :rules="[{ required: true, message: $t('employee.msg.val_firstname') }]">
            <span slot="label" class="hm-cell">{{$t('employee.lbl.firstname')}}</span>
            <el-input v-model="dataForm.firstname" clearable style="width:100%" :placeholder="$t('employee.lbl.firstname')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
          <el-form-item prop="surname" :rules="[ { required: true, message: $t('employee.msg.val_surname') } ]">
            <span slot="label" class="hm-cell">{{$t('employee.lbl.surname')}}</span>
            <el-input v-model="dataForm.surname" clearable style="width:100%" :placeholder="$t('employee.lbl.surname')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4">
          <el-form-item>
            <span slot="label" class="hm-cell">{{$t('employee.lbl.title_suffix')}}</span>
            <el-select v-model="dataForm.title_academic" clearable multiple
              :placeholder="$t('employee.lbl.title_suffix')" style="width:100%">
              <el-option v-for="item in optTitleAcademic"
                :key="item._id" :label="item.name" :value="item._id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- POHLAVIE -->
      <el-row style="margin-top:10px">
        <el-form-item prop="sex" :rules="[{ required: true, message: $t('employee.lbl.sex')}]">
          <span style="color:#606266;font-weight:600">
            <span style="color:#F56C6C">*</span>
            {{$t('employee.lbl.sex')}}
          </span>
          <el-radio-group style="margin-left:20px" v-model="dataForm.sex">
            <el-radio style="color:gray" :label="1">{{$t('employee.lbl.male')}}</el-radio>
            <el-radio style="color:gray" :label="2">{{$t('employee.lbl.female')}}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-row>

      <!-- TELEFON - EMAIL -->
      <el-row :gutter="10">
        <el-col :xs="24" :sm="14" :md="14" :lg="14" :xl="14">
          <el-form-item :label="$t('employee.lbl.email')" prop="email">
            <el-input v-model="dataForm.email" clearable style="width:100%"
              :placeholder="$t('employee.lbl.email')">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="10" :md="10" :lg="10" :xl="10">
          <el-form-item :label="$t('employee.lbl.telephone')" prop="telephone">
            <el-input v-model="dataForm.telephone" clearable style="width:100%">
              <el-select v-model="dataForm.phone_prefix" slot="prepend" style="width:90px">
                <el-option v-for="item in optPhonePrefix" :label="item.label" :value="item.value" :key="item.label"></el-option>
              </el-select>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- ADRESA -->
      <el-divider content-position="left">
        <span style="color:rgb(245, 108, 108);padding:0px !important;margin-right:4px;"><b>*</b></span>
        {{$t('employee.lbl.address.title')}}
        <el-tooltip placement="top" effect="light">
          <i class="far fa-question-circle tool-tip-form"></i>
          <div slot="content">Adresa uvedená v osobním dokladu <br> (např.: Občanský průkaz, pas)</div>
        </el-tooltip>
      </el-divider>
      <div ref="address"></div>
      <el-form-item prop="address_street">
        <!-- ULICA A CISLO -->
        <el-row :gutter="10">
          <el-col :xs="24" :sm="18" :md="18" :lg="18" :xl="18">
            <google-address @complete="fillAddress" :search.sync="dataForm.address_street"
            :options="{style: 'margin-bottom:10px;width:100%'}"></google-address>
          </el-col>
          <el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
            <el-input v-model="dataForm.address_street_nr" :placeholder="$t('employee.lbl.address.house_nr')" clearable style="margin-bottom:10px;width:100%"></el-input>
          </el-col>
        </el-row>
        <!-- MESTO A PSC -->
        <el-row :gutter="10" style="margin-top:0px;">
          <!-- MESTO -->
          <el-col :xs="24" :sm="16" :md="16" :lg="16" :xl="16">
            <el-input v-model="dataForm.city" :placeholder="$t('employee.lbl.address.city')" clearable style="margin-bottom:10px;width:100%"></el-input>
          </el-col>
          <!-- PSC -->
          <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
            <el-input v-model="dataForm.nrzip" clearable :placeholder="$t('employee.lbl.address.nrzip')" style="margin-bottom:10px;width:100%"></el-input>
          </el-col>
        </el-row>
        <!-- KRAJINA -->
        <el-row :gutter="10" style="margin-top:0px;">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-select
              v-model="dataForm.country_id"
              filterable
              reserve-keyword
              clearable
              :placeholder="$t('employee.lbl.address.country')"
              style="width:100%"
              @change="fillCitizenShip()">
              <el-option-group
                v-for="group in optCountry"
                :key="group.key"
                :label="group.label">
                <el-option
                  v-for="item in group.options"
                  :key="item._id"
                  :label="item.name"
                  :value="item._id">
                </el-option>
              </el-option-group>
            </el-select>
          </el-col>
        </el-row>
      </el-form-item>

      <div style="margin-top:40px"></div>
      <el-divider content-position="left">
        {{$t('employee.lbl.contact_address.title')}}
        <el-tooltip placement="top" effect="light">
          <i class="far fa-question-circle tool-tip-form"></i>
          <div slot="content">Adresa pro zasílání dokumentů. <br> Adresa, na které se častěji zdržujete. <br> Uvádíte pouze pokud se liší od trvalého bydliště. </div>
        </el-tooltip>
      </el-divider>
      <!-- KONTAKTNA ADRESA -->
      <el-form-item>
        <!-- ULICA A CISLO -->
        <el-row :gutter="10">
          <el-col :xs="24" :sm="18" :md="18" :lg="18" :xl="18">
            <google-address @complete="fillContactAddress"
              :search.sync="dataForm.contact_address.address_street"
              :options="{
                style: 'margin-bottom:10px;width:100%'
              }">
            </google-address>
          </el-col>
          <el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
            <el-input v-model="dataForm.contact_address.address_street_nr" :placeholder="$t('employee.lbl.address.house_nr')" clearable style="width:100%;margin-bottom:10px;"></el-input>
          </el-col>
        </el-row>
        <!-- MESTO A PSC -->
        <el-row :gutter="10">
          <el-col :xs="24" :sm="16" :md="16" :lg="16" :xl="16">
            <el-input v-model="dataForm.contact_address.city"
              :placeholder="$t('employee.lbl.address.city')"
              clearable
              style="width:100%;margin-bottom:10px;"></el-input>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
            <div>
              <el-input v-model="dataForm.contact_address.nrzip" style="width:100%;margin-bottom:10px;" clearable :placeholder="$t('employee.lbl.address.nrzip')"></el-input>
            </div>
          </el-col>
        </el-row>
        <!-- KRAJINA -->
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-select
              v-model="dataForm.contact_address.country_id"
              filterable
              reserve-keyword
              clearable
              :placeholder="$t('employee.lbl.address.country')"
              style="width:calc(100%)">
              <el-option-group
                v-for="group in optCountry"
                :key="group.key"
                :label="group.label">
                <el-option
                  v-for="item in group.options"
                  :key="item._id"
                  :label="item.name"
                  :value="item._id">
                </el-option>
              </el-option-group>
            </el-select>
          </el-col>
        </el-row>
        <!-- <div style="font-size:13px;line-height:20px;margin-top:10px">
          {{$t('employee.msg.contact_address')}}
        </div> -->
      </el-form-item>

      <div ref="info"></div>
      <!-- AKTUALNY PRACOVNY STAV -->
      <el-row :gutter="10" style="margin-top:20px">
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <el-form-item
            prop="job_status_id"
            :rules="[
              { required: true, message: $t('employee.msg.val_job_status')}
            ]">
            <span slot="label">{{$t('employee.lbl.job_status')}}</span>
            <el-select
              clearable
              v-model="dataForm.job_status_id"
              :placeholder="$t('employee.lbl.job_status')" style="width:100%">
              <el-option
                v-for="item in optJobStatus"
                :key="item._id"
                :label="comboLang(item)"
                :value="item._id">
              </el-option>
            </el-select>
            <div style="margin-top:5px;font-size:13px;line-height:20px;color:#E30015"
              v-show="infoStudent()" v-html="$t('employee.msg.job_status_student')">
            </div>
          </el-form-item>
        </el-col>
        <!-- NAJVYSSIE DOSIAHNUTE VZDELANIE -->
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <el-form-item
            prop="education_level_id"
            :rules="[
              { required: true, message: $t('employee.msg.val_education_level')}
            ]">
            <span slot="label">{{$t('employee.lbl.education_level')}}</span>
            <el-select v-model="dataForm.education_level_id"
              clearable
              :placeholder="$t('employee.lbl.education_level')"
              style="width:100%">
              <el-option
                v-for="item in optEducationLevel"
                :key="item._id"
                :label="comboLang(item)"
                :value="item._id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- RODNE CISLO -->
      <el-row style="margin-top:30px;">
        <el-col :span="24">
          <el-form-item
            prop="birth_nr">
            <span slot="label">
              {{$t('employee.lbl.birth_nr')}}
              <el-tooltip placement="top" effect="light">
                <i class="far fa-question-circle tool-tip-form"></i>
                <div slot="content">Pokud nemáte rodné číslo, uveďte <b>1111111111</b> (10x1)</div>
              </el-tooltip>
            </span>
            <el-input v-model="dataForm.birth_nr"
              clearable
              style="width:100%"
              :placeholder="$t('employee.lbl.birth_nr')" @blur="computeBirtDay()"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- DATUM NARODENIA, MIESTO NARODENIA, KRAJINA NARODENIA -->
      <el-row :gutter="10">
        <!-- DATUM NARODENIA -->
        <el-col :xs="24" :sm="8" :md="6" :lg="5" :xl="5">
          <el-form-item prop="xbirth_date">
            <span slot="label" class="hm-cell">{{$t('employee.lbl.birth_date')}}</span>
            <el-date-picker
              v-model="xbirth_date"
              format="dd.MM.yyyy"
              type="date"
              :placeholder="$t('employee.lbl.birth_date')"
              clearable
              style="width:100%">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <!-- MIESTO NARODENIA -->
        <el-col :xs="24" :sm="16" :md="18" :lg="8" :xl="8">
          <el-form-item
            prop="place_of_birth"
            :rules="[
              { required: true, message: $t('employee.msg.val_place_of_birth')}
            ]">
            <span slot="label" class="hm-cell">{{$t('employee.lbl.place_of_birth')}}</span>
            <google-address @complete="fillPlaceOfBirth"
              :search.sync="dataForm.place_of_birth" code="city"
              :options="{
                placeholder: $t('employee.lbl.place_of_birth'),
                style: 'width:100%'
              }">
            </google-address>
          </el-form-item>
        </el-col>
        <!-- KRAJINA NARODENIA -->
        <el-col :xs="24" :sm="24" :md="24" :lg="11" :xl="11">
          <el-form-item
            prop="country_of_birth_id"
            :rules="[
              { required: true, message: $t('employee.lbl.country_of_birth')}
            ]">
            <span slot="label" class="hm-cell">{{$t('employee.lbl.country_of_birth')}}</span>
            <el-select
              v-model="dataForm.country_of_birth_id"
              filterable
              reserve-keyword
              clearable
              :placeholder="$t('employee.lbl.country_of_birth')"
              style="width:100%">
              <el-option-group
                v-for="group in optCountry"
                :key="group.key"
                :label="group.label">
                <el-option
                  v-for="item in group.options"
                  :key="item._id"
                  :label="item.name"
                  :value="item._id">
                </el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <div ref="end_form"></div>
      <!-- RODNE PRIEZVISKO - VSETKY PREDCHADZAJUCE PRIEZVISKA-->
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <el-form-item
            prop="family_name"
            :rules="[
              { required: true, message: $t('employee.msg.val_family_name')}
            ]">
            <span slot="label" class="hm-cell">
              {{$t('employee.lbl.family_name')}}
              <el-tooltip placement="top" effect="light">
                <i class="far fa-question-circle tool-tip-form"></i>
                <div slot="content">Uveďte i v případě že je shodné s Vaším aktuálním příjmením</div>
              </el-tooltip>
            </span>
            <el-input v-model="dataForm.family_name" clearable style="width:100%" :placeholder="$t('employee.lbl.family_name')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <el-form-item>
            <span slot="label" class="hm-cell">{{$t('employee.lbl.family_name_all')}}</span>
            <el-input v-model="dataForm.family_name_all"
              clearable
              style="width:100%"
              :placeholder="$t('employee.lbl.family_name_all')"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- STATNE OBCIANSTVO -->
      <el-row style="margin-top:30px">
        <el-col :span="24">
          <el-form-item
            prop="citizenship_id"
            :rules="[
              { required: true, message: $t('employee.msg.val_citizenship')}
            ]">
            <span slot="label" class="hm-cell">{{$t('employee.lbl.citizenship')}}</span>
            <el-select v-model="dataForm.citizenship_id"
              clearable
              filterable
              :placeholder="$t('employee.lbl.citizenship')" style="width:100%"
              @change="citizenChange">
              <el-option-group
                v-for="group in optCountry"
                :key="group.key"
                :label="group.label">
                <el-option
                  v-for="item in group.options"
                  :key="item._id"
                  :label="item.name"
                  :value="item._id">
                </el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- CISLO POISTENIA A DOKUMENTU-->
      <transition name="el-zoom-in-bottom">
        <el-row v-show="showExtFields" :gutter="10">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <!-- CISLO POISTENIA -->
            <el-form-item prop="insurance_number"
              :rules="[
                { message: $t('employee.msg.val_insurance_number')}
              ]">
              <span slot="label" class="hm-cell">{{$t('employee.lbl.insurance_number')}}</span>
              <el-input v-model="dataForm.insurance_number" style="width:100%" :placeholder="$t('employee.lbl.insurance_number')" clearable></el-input>
            </el-form-item>
          </el-col>
          <!-- CISLO DOKUMENTU -->
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item prop="document_number">
              <span slot="label" class="hm-cell">
                {{$t('employee.lbl.document_number')}}
                <el-tooltip placement="top" effect="light">
                  <i class="far fa-question-circle tool-tip-form"></i>
                  <div slot="content">Například občanský průkaz, pas,..</div>
                </el-tooltip>
              </span>
              <el-input v-model="dataForm.document_number" style="width:100%" :placeholder="$t('employee.lbl.document_number')" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </transition>

      <!-- RODINNY STAV -->
      <el-row>
        <el-col :span="24">
          <el-form-item
            prop="marital_status_id"
            :rules="[
              { required: true, message: $t('employee.msg.val_marital_status')}
            ]">
            <span slot="label" class="hm-cell">{{$t('employee.lbl.marital_status')}}</span>
            <el-select v-model="dataForm.marital_status_id"
              clearable
              :placeholder="$t('employee.lbl.marital_status')"
              style="width:100%">
              <el-option
                v-for="item in optMaritalStatus"
                :key="item._id"
                :label="item.name"
                :value="item._id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- ZDRAVOTNA POISTOVNA -->
      <el-row style="margin-top:30px">
        <el-col :span="24">
          <el-form-item
            prop="health_insurance_id"
            :rules="[
              { required: true, message: $t('employee.msg.val_health_insurance')}
            ]">
            <span slot="label" class="hm-cell">{{$t('employee.lbl.health_insurance')}}</span>
            <el-select v-model="dataForm.health_insurance_id"
              clearable
              :placeholder="$t('employee.lbl.health_insurance')"
              style="width:100%">
              <el-option
                v-for="item in optHealthInsurance"
                :key="item._id"
                :label="item.name"
                :value="item._id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- BANKA -->
      <el-row :gutter="10">
        <el-col :xs="24" :sm="18" :md="18" :lg="18" :xl="18">
          <el-form-item>
            <span slot="label" class="hm-cell">{{$t('employee.lbl.bank_account')}}</span>
            <el-input v-model="dataForm.bank_account"
              clearable
              style="width:100%"
              :placeholder="$t('employee.lbl.bank_account')">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
          <el-form-item>
            <span slot="label" class="hm-cell">{{$t('employee.lbl.bank_code')}}</span>
            <el-input v-model="dataForm.bank_code"
              clearable
              style="width:100%"
              :placeholder="$t('employee.lbl.bank_code')">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- SLOTs -->
      <slot name="upload"></slot>
      <slot name="footer" :save="validateForm"></slot>
    </el-form>
  </div>
</template>

<script>
/* eslint-disable camelcase */
/* eslint-disable brace-style */
/* eslint-disable one-var */
/* eslint-disable standard/object-curly-even-spacing */

import {fetchDataCombo} from '@/api/data'
import validity from '@/components/HMEmployeeForm/mixins/validity'
import GoogleAddress from '@/components/HMGoogleAddress/index.vue'

export default {
  name: 'EmpForm',
  props: ['dataForm', 'optData'],
  /**
   * PROPS
   *  options: {
   *    width(volitelny): Number,   -> sirka k akej sa budu el-componenty prisposobovat
   *    headers(volitelny): {}      -> vyuzivam pre nacitanie ciselnikov na zaklade PINu
   *    list(volitelny): true | false
   *        -> ak list neni nastaveny cisleniky sa nacitaju automaticky,
   *        -> ak list je nastaveny na false cisleniky sa nenacitaju a cakaju kym sa z list nestane true
   *  }
   */
  mixins: [validity],
  components: {
    'google-address': GoogleAddress
  },
  data () {
    // --- RULES ---
    var checkEmail = (p_rule, p_value, callback) => {
      if (p_value) {
        if (this.validEmail(p_value) === false) {
          callback(new Error('Email nemá správný formát. Správný tvar: neco@neco.neco'))
        } else {
          callback()
        }
      }
    }
    var checkTelephone = (p_rule, p_value, callback) => {
      if (p_value) {
        if (!this.dataForm.phone_prefix) {
          callback(new Error('Zvolte předvolbu tel. čísla.'))
        }
        if (this.validTelephone(p_value) === false) {
          callback(new Error('Telefonní číslo nemá správný formát. Příklad: +420775123456'))
        } else {
          callback()
        }
      }
      else {
        callback()
      }
    }
    var checkBirthNr = (p_rule, p_value, callback) => {
      if (p_value) {
        let result = this.validBirtNr(p_value)
        if (result.status === false) {
          callback(new Error(result.err_msg))
        }
        else {
          callback()
        }
      }
    }
    var checkBirthDate = (p_rule, p_value, callback) => {
      if (!this.xbirth_date) {
        callback(new Error('Datum narození je povinné vyplnit.'))
      }
      if (this.validBirtDate(this.xbirth_date) === false) {
        callback(new Error('Neplatné datum.'))
      }
      else {
        callback()
      }
    }
    var checkAddress = (p_rule, p_value, callback) => {
      if (!this.dataForm.address_street) {
        callback(new Error(this.$t('employee.msg.val_address')))
        return
      }
      if (!this.dataForm.address_street_nr) {
        callback(new Error(this.$t('employee.msg.val_address')))
        return
      }
      if (!this.dataForm.city) {
        callback(new Error(this.$t('employee.msg.val_address')))
        return
      }
      if (!this.dataForm.nrzip) {
        callback(new Error(this.$t('employee.msg.val_address')))
        return
      }
      if (!this.dataForm.country_id) {
        callback(new Error(this.$t('employee.msg.val_address')))
        return
      }
      // sicko je OK
      callback()
    }
    var checkDocumentNumber = (p_rule, p_value, callback) => {
      if (this.showExtFields === true) { // kontroluj len ak je field document_number viditelny(to znamena ina krajina ako Cesko)
        if (!this.dataForm.document_number) {
          callback(new Error(this.$t('employee.msg.val_document_number')))
          return
        }
        if (this.dataForm.document_number && this.dataForm.document_number.replace(/ /g, '').length < 1) {
          callback(new Error(this.$t('employee.msg.val_document_number')))
        }
        else {
          callback()
        }
      }
      else {
        callback()
      }
    }
    // --- ***** ---
    return {
      options: undefined,
      xbirth_date: undefined,
      showExtFields: false,
      optJobStatus: [],
      optMaritalStatus: [],
      optEducationLevel: [],
      optCountry: [], // STATNE OBCIANSTVO a KRAJINA pouzivaju ten isty ciselnik
      optCountryLoaded: false,
      optHealthInsurance: [],
      optTitle: [],
      optTitleAcademic: [],
      optPhonePrefix: [
        { label: '+420', value: '+420' },
        { label: '+421', value: '+421' },
        { label: '+359', value: '+359' }, // bulgaria
        { label: '+373', value: '+373' }, // moldava
        { label: '+375', value: '+375' }, // belarus
        { label: '+380', value: '+380' }, // ukraine
        { label: '+381', value: '+381' }, // serbia
        { label: '+385', value: '+385' } // croatia
      ],
      rules: {
        telephone: [
          { validator: checkTelephone, trigger: 'blur'}
        ],
        email: [
          { required: true, message: 'Email je povinné vyplnit.'},
          { validator: checkEmail, trigger: 'blur'}
        ],
        birth_nr: [
          { required: true, message: 'Rodné číslo je povinné vyplnit.'},
          { validator: checkBirthNr, trigger: 'blur'}
        ],
        xbirth_date: [
          // { required: true, message: 'Datum narození je povinné vyplnit.'},
          { required: true, validator: checkBirthDate, trigger: 'blur'}
        ],
        address_street: [
          { required: true, validator: checkAddress, trigger: 'blur'}
        ],
        document_number: [
          { required: true, validator: checkDocumentNumber, trigger: 'blur'}
        ]
      }
    }
  },
  watch: {
    xbirth_date: function (newVal) {
      this.dataForm.birth_date = newVal
    },
    optCountryLoaded: function (is_loaded) {
      if (is_loaded === true) {
        if (this.dataForm.citizenship_id) { // ak pri nacitani detailu uz je vyplnene citizenship_id...
          this.citizenChange(this.dataForm.citizenship_id) // zobraz dalsie fieldy ak krajina je ina ako czech
        }
      }
    },
    'dataForm.citizenship_id': function (newVal) {
      this.citizenChange(newVal)
    }
  },
  created () {
    this.options = this.optData ? this.optData : {}
    this.options.width = this.options.width ? this.options.width : window.innerWidth // defaultna sirka podla rozlisenia

    if (this.options) {
      if (typeof this.options.list === 'undefined') {
        this.list() // ak list nebol zadefinovany(je undefined), rovno spusti citanie ciselnikov
      } else {
        this.$watch('options.list', () => {
          // CISELNIKY
          if (this.options.list === true) {
            this.list()
          }
        }, {
          deep: true,
          immediate: true
        })
      }
    } else {
      this.list() // ak options nebol zadefinovany(je undefined), rovno spusti citanie ciselnikov
    }
    // ---
    this.xbirth_date = this.dataForm.birth_date ? this.dataForm.birth_date : this.xbirth_date
    this.phonePrefixParse()
  },
  mounted () {
    window.addEventListener('resize', () => {
      this.options.width = window.innerWidth
    })
  },
  methods: {
    phonePrefixParse () {
      var _ = require('lodash')
      let prefix = this.dataForm.telephone
      prefix = prefix.substring(0, 4)
      let index = _.findIndex(this.optPhonePrefix, function (o) { return o.value === prefix })
      if (index > -1) {
        this.dataForm.phone_prefix = prefix
        this.dataForm.telephone = this.dataForm.telephone.replace(prefix, '')
      }
    },
    comboLang (item) {
      if (this.$i18n.locale === 'sk') { // defaultne
        return item.name
      } else {
        if (!item.lang) { // nema polozka lang? => vrat item.name
          return item.name
        }
        if (!item.lang[this.$i18n.locale]) { // polozka ma lang ale nema lang.ua? => vrat item.name
          return item.name
        } else { // zda sa ze preklad je OK, vrat teda preklad
          return item.lang[this.$i18n.locale]
        }
      }
    },
    list () {
      this.fetchDataCombo('title', 'optTitle')
      this.fetchDataCombo('title_academic', 'optTitleAcademic')
      this.fetchDataCombo('job_status', 'optJobStatus')
      this.fetchDataCombo('education_level', 'optEducationLevel')
      this.fetchDataCombo('marital_status', 'optMaritalStatus')
      this.fetchDataCombo('country', 'optCountry')
      this.fetchDataCombo('health_insurance', 'optHealthInsurance')
    },
    infoStudent () {
      let result = false
      this.optJobStatus.find(o => {
        if (o._id === this.dataForm.job_status_id) {
          if (o.name.toLowerCase() === 'student') {
            result = true
          }
        }
      })
      return result
    },
    citizenChange (p_id) { // ak sa zvoli statne obcianstvo ine ako ceske, zobrazia sa dalsie dva fieldy na vyplnenie
      // console.log('before citizenChange =>', p_id, 'showExtFields', this.showExtFields)
      if (!p_id) return
      // ---
      let go = true
      let index = 0
      let obj
      do {
        /**
         * FORMAT this.optCountry => [{
         *    label: '',
         *    options: [{_id: '***', code: '***', name: '***'}, {_id: '***', code: '***', name: '***'}...{}],
         *    key: 1
         * }, {
         *    label: '',
         *    options: [{_id: '***', code: '***', name: '***'}, {_id: '***', code: '***', name: '***'}...{}],
         *    key: 2
         * }]
         */
        this.optCountry[index].options.find(o => {
          if (o._id === p_id) {
            obj = o
            go = false
          }
        })
        index++
      } while (go === true && index < this.optCountry.length)
      if (obj.code !== 'CZ') {
        this.showExtFields = true
      } else {
        this.showExtFields = false
      }
      // console.log('before citizenChange =>', p_id, 'showExtFields', this.showExtFields)
    },
    computeBirtDay () {
      let result = this.validBirtNr(this.dataForm.birth_nr)
      if (result.status) {
        this.xbirth_date = result.date_of_birth
      }
    },
    findCountryByCode (p_code) { // ked sa vrati z google adresa, podla kodu krajiny sa skusi vyhladat a vyplnit krajina z ciselniku optCountry
      if (!p_code) return
      // ---
      let go = true
      let index = 0
      let obj
      do {
        /**
         * FORMAT this.optCountry => [{
         *    label: '',
         *    options: [{_id: '***', code: '***', name: '***'}, {_id: '***', code: '***', name: '***'}...{}],
         *    key: 1
         * }, {
         *    label: '',
         *    options: [{_id: '***', code: '***', name: '***'}, {_id: '***', code: '***', name: '***'}...{}],
         *    key: 2
         * }]
         */
        this.optCountry[index].options.find(o => {
          if (o.code === p_code) {
            obj = o
            go = false
          }
        })
        index++
      } while (go === true && index < this.optCountry.length)
      // ---
      return obj
    },
    fillCitizenShip () {
      if (!this.dataForm.citizenship_id) { // ak neni statne obcianstvo este vyplnene
        this.dataForm.citizenship_id = this.dataForm.country_id
        this.citizenChange(this.dataForm.citizenship_id)
      }
    },
    fillAddress (p_obj) {
      if (!p_obj) return
      // ---
      this.dataForm.address_street = p_obj.street
      this.dataForm.address_street_nr = p_obj.street_number
      this.dataForm.nrzip = p_obj.postal_code
      this.dataForm.city = p_obj.city
      let country = this.findCountryByCode(p_obj.country_code)
      if (country) { // ak sa krajina z google komponentu nasla v ciselniku, vypln rovno combo krajina
        this.dataForm.country_id = country._id
        this.citizenChange(country._id)
      }
    },
    fillContactAddress (p_obj) {
      if (!p_obj) return
      // ---
      this.dataForm.contact_address = { // z nejakeho picovskeho dovodu to musi byt takto :(
        address_street: p_obj.street,
        address_street_nr: p_obj.street_number,
        nrzip: p_obj.postal_code,
        city: p_obj.city,
        country_id: undefined
      }
      let country = this.findCountryByCode(p_obj.country_code)
      if (country) { // ak sa krajina z google komponentu nasla v ciselniku, vypln rovno combo krajina
        this.dataForm.contact_address.country_id = country._id.toString()
      }
    },
    fillPlaceOfBirth (p_obj) {
      this.dataForm.place_of_birth = p_obj.city
      let country = this.findCountryByCode(p_obj.country_code)
      if (country) { // ak sa krajina z google komponentu nasla v ciselniku, vypln rovno combo krajina
        this.dataForm.country_id = country._id
        this.dataForm.country_of_birth_id = country._id
      }
    },
    validate (callback) {
      // this.$refs['form'].resetFields()
      this.$refs['form'].validate((valid, err_fields) => {
        callback(valid, err_fields)
      })
    },
    validateForm () {
      this.validate((valid, err_fields) => { // validuj formular ci je ok...
        if (valid) {
          this.$emit('save') // volaj funkciu v parentovi, ktora je definovana v @save
        }
        else {
          let field_name = Object.keys(err_fields)[0] // najdi prvy nevalidny field
          let to = 0
          var arr_name = ['firstname', 'surname', 'sex', 'telephone', 'email']
          if (arr_name.indexOf(field_name.toString()) > -1) {
            to = this.$refs['name'].offsetTop - 60
          }
          var arr_address = ['address_street']
          if (arr_address.indexOf(field_name.toString()) > -1) {
            to = this.$refs['address'].offsetTop - 60
          }
          var arr_info = ['job_status_id', 'education_level_id', 'birth_nr', 'xbirth_date', 'place_of_birth', 'country_of_birth_id']
          if (arr_info.indexOf(field_name.toString()) > -1) {
            to = this.$refs['info'].offsetTop - 60
          }
          var arr_end_form = ['family_name', 'citizenship_id', 'insurance_number', 'document_number', 'health_insurance_id']
          if (arr_end_form.indexOf(field_name.toString()) > -1) {
            to = this.$refs['end_form'].offsetTop - 60
          }
          // ---
          window.scrollTo({
            top: to,
            left: 0,
            behavior: 'smooth'
          }) // skroluj hore nech si ho prejde znova, ma tam chybu
        }
      })
    },
    fetchDataCombo (p_cd_rel, p_optCombo) {
      let headers = {}
      if (this.optData && this.optData.headers) {
        headers = this.optData.headers
      }
      fetchDataCombo({cd_rel: p_cd_rel, form_id: this.$route.params.formID}, headers).then(response => {
        if (p_cd_rel === 'country') {
          let popular_country_code = ['cz', 'sk']
          let
            popular_country = [],
            other_country = []
          for (let index = 0; index < response.data.data.length; index++) {
            const row = response.data.data[index]
            if (popular_country_code.indexOf(row.code.toString().toLowerCase()) > -1) {
              popular_country.push(row)
            } else {
              other_country.push(row)
            }
          }
          this[p_optCombo] = [
            {
              label: '', // 'Populární země',
              options: popular_country,
              key: 1
            },
            {
              label: '', // 'Ostatní země',
              options: other_country,
              key: 2
            }
          ]
          this.optCountryLoaded = true // ciselnik country bol uspesne nacitany
        } else {
          this[p_optCombo] = response.data.data
        }
      }).catch(err => {
        console.error(`[HMEmployeeForm/index.vue] p_cd_rel => ${p_cd_rel}, fetchDataCombo ! err`, err)
      })
    }
  }
}
</script>

<style>
  .tool-tip-form {
    color:#409EFF;
    margin-left:7px;
    cursor:help;
  }
  .tool-tip-form:hover {
    color:#303133;
  }
</style>



// WEBPACK FOOTER //
// src/components/HMEmployeeForm/index.vue